var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile newalumni-directory-div" }, [
    _c(
      "div",
      { staticClass: "search" },
      [
        _c("van-search", {
          attrs: { shape: "round", placeholder: "搜索" },
          on: { input: _vm.search },
          model: {
            value: _vm.keywords,
            callback: function ($$v) {
              _vm.keywords = $$v
            },
            expression: "keywords",
          },
        }),
      ],
      1
    ),
    _vm.dataList.length > 0
      ? _c(
          "div",
          { staticClass: "newalumni-directory-main" },
          _vm._l(_vm.dataList, function (item, index) {
            return _c(
              "div",
              {
                key: "alumnidirectorylist" + index,
                staticClass: "newalumni-directory-list",
              },
              [
                _c(
                  "div",
                  { staticClass: "newalumni-directory-list-headtitle" },
                  [_vm._v(" " + _vm._s(item.title || "") + " ")]
                ),
                _c(
                  "div",
                  { staticClass: "newalumni-directory-list-content" },
                  _vm._l(item.alumniBooks, function (tempInfo, tempIndex) {
                    return _c(
                      "div",
                      {
                        key: "alumnidirectorylistitem" + tempIndex,
                        staticClass: "newalumni-directory-list-item",
                        on: {
                          click: function ($event) {
                            return _vm.clickListItem(tempInfo)
                          },
                        },
                      },
                      [
                        _c(
                          "DsfMobileTeasCell",
                          {
                            attrs: {
                              headerUrl: tempInfo.photo || _vm.defaultImg,
                              title: tempInfo.name || "&nbsp;",
                              cellShape: "none",
                              border: true,
                            },
                          },
                          [
                            _c("DsfMobileTeasCellItem", {
                              attrs: { value: tempInfo.phone || "&nbsp;" },
                            }),
                            _c("DsfMobileTeasCellItem", {
                              attrs: { value: tempInfo.job || "暂无单位" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "alumni-directory-main" },
          [_c("van-empty", { attrs: { description: "暂无数据" } })],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }